export function getLegacyState() {
  return window.S;
}

export function getLegacyBusinessState() {
  return window.BIZ_STATE;
}
